export interface HostLanguageChangeDetail {
  lang: string;
  timestamp: number;
}

export class HostLanguageChangeEvent extends CustomEvent<HostLanguageChangeDetail> {
  static readonly eventType = 'host-language-change';

  constructor(detail: HostLanguageChangeDetail) {
    super(HostLanguageChangeEvent.eventType, { detail });
  }
}
